<template>
    <div class="slide">

        <go-back />

        <div class="slide-container">

            <div class="question">

                Any <span>other sources of income</span> you would like to enter?

                <div class="description">
                    This would be incomes other than work and pension.
                </div>

            </div>

            <div class="answer answer-col">
                <span class="alternative" @click="next('yes')">Yes</span>
                <span class="alternative" @click="next('no')">No</span>
            </div>

        </div>

    </div>
</template>

<script>
import GoBack from "./GoBack";

export default {
    name: 'HaveIncome',
    components: {
        GoBack
    },
    methods: {
        next( haveOtherIncome ) {
            if ( haveOtherIncome === 'yes' ) {
                this.$router.push({ name: 'Income' });
            } else {
                this.$router.push({ name: 'HaveSavings' });
            }
        }
    }
}
</script>
